module.exports = __webpack_public_path__ + "media/heroes/media-kit-hero-mobile-99d66daa.jpg";